import styled from "styled-components";

export const Container = styled.div`
  background-color: #2125298f;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
`;
